import { useContext } from 'react';
import { ResumeContext } from "../../../context/resume/resume-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import DiplomaItem from "./DiplomaItem";

export default function DiplomaList() {

    const { refEducationLevels } = useContext( ResumeContext );
    const { diplomas } = useResumeDocumentSection();

    return (
        <div>
            { diplomas
                ?.sort( ( a, b ) => a.order - b.order )
                .map( diploma => (
                    <DiplomaItem
                        key={ diploma.order }
                        item={ diploma }
                        numberOfItems={ diplomas.length }
                        refEducationLevels={ refEducationLevels }
                    />
                ) ) }
        </div>
    );
}
